<script lang="ts" setup>
import { nextTick, ref, watch } from 'vue';
import { debouncedWatch } from '@vueuse/core';

const props = withDefaults(
  defineProps<{
    placeholder?: string;
    clear?: boolean;
    onFocus?: boolean;
  }>(),
  {
    placeholder: 'Zoeken...'
  }
);

const emit = defineEmits<{ input: [string]; onTab: [] }>();

const val = ref<string>('');
const root = ref();

watch(
  () => props.onFocus,
  () => {
    nextTick(() => root.value?.focus());
  },
  { immediate: true }
);

debouncedWatch(
  () => val.value,
  () => {
    emit('input', val.value);
  },
  { debounce: 300 }
);

watch(
  () => props.clear,
  () => clearSearch()
);

function clearSearch() {
  val.value = '';
  emit('input', val.value);
}

function onKeyDown(event: KeyboardEvent) {
  if (event.code === 'Tab') emit('onTab');
}
</script>

<template>
  <form class="search" @submit.prevent>
    <div class="control has-icons-left has-icons-right">
      <input
        ref="root"
        type="search"
        autocomplete="on"
        class="input"
        :placeholder="placeholder"
        v-model="val"
        data-testid="v-search"
        @keydown="onKeyDown" />
      <span class="icon is-left tw-cursor-pointer">
        <FontAwesomeIcon icon="fa-regular fa-search" />
      </span>
      <span v-if="val" @click="clearSearch" class="icon is-right tw-cursor-pointer" data-testid="v-search-clear">
        <FontAwesomeIcon icon="fa-regular fa-times" class="tw-font-bold" />
      </span>
    </div>
  </form>
</template>

<style lang="scss" scoped>
.search {
  input {
    border: 1px solid $borders;
    box-shadow: none;
  }
  .icon {
    color: $grey-medium;
  }
}
</style>
